import type { PlatformUser } from '@/stores/auth'
import { useAuthStore, useUser } from '@/stores/authStore'
import { CheckCircle } from 'lucide-react'
import Logo from './ui/Logo'

export function FeaturesInfoPanel() {
	const user = useUser() as PlatformUser | null
	const currentOrgId = useAuthStore(state => state.currentOrganizationId)

	// Resolve branding from current org
	const org = currentOrgId ? user?.organizations?.find(o => o.id === currentOrgId) : null
	const brandMark = org?.frontend_settings?.branding?.brand_mark || null
	const companyName = 'Bytebeam'

	const features = [
		'Real-time monitoring',
		'Secure OTA updates',
		'Advanced analytics',
		'Custom Alerts and Notifications',
		'Mobile-device communication',
		'Built-in DBC parsing',
	]

	return (
		<div className='relative hidden md:block border-r border-border'>
			<div className='relative z-10 p-6'>
				{brandMark ? (
					<div className='size-12 rounded-xl overflow-hidden border border-border flex items-center justify-center bg-muted'>
						<img src={brandMark} className='size-full object-cover' alt='logo' />
					</div>
				) : (
					<Logo height='40' />
				)}
				<h2 className='text-form-modal-title font-bold mb-2'>Powering the Future of IoT Devices</h2>
				<p className='text-control text-foreground/70'>
					{companyName} is an all-in-one cloud backend platform for IoT, helping you manage your devices at any scale
					with ease and confidence.
				</p>

				<ul className='mt-6 space-y-3 text-control font-bold'>
					{features.map(feature => (
						<li key={feature} className='flex items-center space-x-2 text-foreground/90'>
							<CheckCircle className='size-4 text-icon-success' />
							<span>{feature}</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}
